<template>
    <div :class="[layout, { 'col-md-4 col-sm-6 col-xs-12': layout == 'big', 'col-md-2 col-sm-3 col-xs-4': layout == 'small' }]"
         class="card cursor-pointer"
         @click="$router.push(item.uri)">
        <v-img :item="item" :img="item.img" :key="item.img.url" :is-video="isVideo">
            <div class="image-caption-category" v-if="item.category">
                <h5 class="q-mt-none q-mb-xs banner-title text-white">{{ $T(item.category) }}</h5>
            </div>
        </v-img>
        <h5 class="q-mt-md q-mb-xs" v-html="item.title"></h5>
        <p v-if="item.subtitle" class="q-ma-none" v-html="item.subtitle"></p>
    </div>
</template>

<script>
    export default {
        name: 'VCard',

        props: {
            layout: {
                type: String,
                required: true
            },
            item: {
                type: Object,
                required: true
            },
            isVideo: Boolean
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/front/Card.vue